import { ServiceError } from './errors';

export async function get<T>(
  apiUrl: string,
  token: string,
  uri: string,
  basicAuth: boolean = false
): Promise<T> {
  try {
    const authHeader = basicAuth ? `Basic ${token}` : `Bearer ${token}`;

    const result = await fetch(`${apiUrl}${uri}`, {
      method: 'get',
      headers: new Headers({
        Authorization: authHeader,
        'Content-Type': 'application/json'
      })
    });

    if (result.status === 203)
      throw new ServiceError(
        'No Access to Organization',
        'Your token does not have the required permissions'
      );

    const data = await result.json();
    if (result.ok) return data as T;

    const message =
      data?.message || data?.error_description || result.statusText;

    if (message === 'Bad credentials')
      throw new ServiceError(
        'Bad Credentials',
        'This token has been revoked or expired. Please sign in again.'
      );

    if ((result.status >= 400 && result.status < 500) || result.status === 203)
      throw new ServiceError('No Access to Organization', message);

    throw new Error(message);
  } catch (error: any) {
    // Fetch only throws a TypeError when a network error occurs
    if (error.message === 'Failed to fetch' && apiUrl.startsWith('http://')) {
      throw new ServiceError(
        'Connection Not Secure',
        `Your remote is not secure (${apiUrl}). <a href="https://support.google.com/chrome/answer/114662?hl=en-GB&co=GENIE.Platform%3DDesktop&sjid=6808987561758329233-EU" target="_blank">Allow insecure content in your browser settings</a> for <a href="https://app.git.live/">app.git.live</a> to use GitLive with this remote and try again.`
      );
    }
    throw error;
  }
}
